import { z } from 'zod';
import { DOCUMENT_ID_LENGTH } from '../constants';

// applicationId is the pre-application identifier (= quote/trackingId), not
// the 8-char Application.id — same reasoning as createTitleOwnerDocument.
export const titleOwnerDocumentOperationSchema = z.object({
  applicationId: z.string().min(1, 'applicationId is required'),
  titleSearchOwnerId: z.string().min(1, 'titleSearchOwnerId is required'),
  documentId: z.string().length(DOCUMENT_ID_LENGTH, `Document ID must be ${DOCUMENT_ID_LENGTH} characters long`),
});
